import request from '@/utils/request';
export const getBlogList = () => {
  return request({
    url: '/jdc-data/jdc-data/jiannuBIaoqian',
    method: 'post',
    params: {}
  })
}
export const getNewsList = (paramap) => {
  return request({
    url: '/jdc-data/jdc-data/page',
    method: 'get',
    params: paramap
  })
}

export const getDetail = (id) => {
  return request({
    url: `/jdc-data/jdc-data/one?id=${id}`,
    method: 'get',
  })
}


